<template>
  <v-container fluid grid-list-sm>
    <v-card tile flat>
      <v-card-text>
        <p class="subheading mb-1">温馨提示</p>
        <ul>
          <li>保存：为了防止您在填写时丢失信息，请经常按“保存”按钮。</li>
          <li>* 表示必填项。</li>
        </ul>
      </v-card-text>
    </v-card>

    <!-- 按钮工具栏 -->
    <v-card-actions>
      <v-btn color="orange" depressed :disabled="loadingIndicators['save'] === true || isReadonly"
             @click.native="onSave">
        {{ loadingIndicators['save'] ? '处理中...' : '保存' }}
      </v-btn>
      <v-btn color="secondary" depressed @click.native="goBack">返回</v-btn>
      <v-spacer/>
      <v-btn color="success" depressed :disabled="loadingIndicators['save'] === true || isReadonly"
             @click="validateForm">填写检查
      </v-btn>
    </v-card-actions>

    <!-- 表单校验结果 -->
    <v-alert v-if="formValidErrors.length === 0"
             v-model="showFormValidMsg" dismissible color="rgba(36, 190, 6, 0.41)" style="color: black">
      <ul>
        <li>表单填写完整，可以提交。</li>
      </ul>
    </v-alert>
    <v-alert v-else
             v-model="showFormValidMsg" dismissible color="#ff5252a8" style="color: black">
      <p class="subheading mb-1">填写检查发现以下问题：</p>
      <ol>
        <li v-for="(it, idx) in formValidErrors" :key="idx">
          <strong>{{ it.fieldLabel }}</strong>
          <span v-for="err in it.fieldErrors">{{ err }}</span>
        </li>
      </ol>
    </v-alert>

    <!-- 表单内容 -->
    <v-card flat tile>
      <v-card-text>
        <v-form v-model="formValid" ref="formRef" lazy-validation>
          <h2 class="text-xs-center" style="height: 1.5em">
            企业信息
          </h2>

          <v-tabs v-model="tabs" show-arrows>
            <v-tab>企业基本信息</v-tab>
          </v-tabs>
          <v-divider/>

          <v-tabs-items v-model="tabs">
            <!--企业基本信息-->
            <v-tab-item>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field
                        label="企业名称"
                        v-model="item.qymc"
                        :rules="[required, maxLength(50)]"
                        :readonly="isReadonly"
                      />
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                        label="统一信用代码"
                        v-model="item.tyxydm"
                        :rules="[required, maxLength(50)]"
                        :readonly="isReadonly"
                      />
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-autocomplete
                        label="企业所在州市"
                        :items="cityItems"
                        v-model="item.szzs"
                        :rules="[required]"
                        :readonly="isReadonly"
                        clearable
                      />
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-autocomplete
                        :items="typeItems"
                        label="企业类型"
                        v-model="item.qylx"
                        :rules="[required]"
                        :readonly="isReadonly"
                        clearable/>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                        label="已贴息金额"
                        v-model="item.ytxje"
                        :rules="[required,  decimal(2)]"
                        :readonly="isReadonly"
                        suffix="元"
                      />
                    </v-flex>
                    <v-flex xs12 sm12>
                      <v-text-field
                        label="备注"
                        v-model="item.bz"
                        :rules="[required,  maxLength(200)]"
                        :readonly="isReadonly"
                      />
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>
        </v-form>
      </v-card-text>
    </v-card>


    <!-- 表单校验结果 -->
    <v-alert v-if="formValidErrors.length === 0"
             v-model="showFormValidMsg" dismissible color="rgba(36, 190, 6, 0.41)" style="color: black">
      <ul>
        <li>表单填写完整，可以提交。</li>
      </ul>
    </v-alert>
    <v-alert v-else
             v-model="showFormValidMsg" dismissible color="#ff5252a8" style="color: black">
      <p class="subheading mb-1">填写检查发现以下问题：</p>
      <ol>
        <li v-for="(it, idx) in formValidErrors" :key="idx">
          <strong>{{ it.fieldLabel }}</strong>
          <span v-for="err in it.fieldErrors">{{ err }}</span>
        </li>
      </ol>
    </v-alert>

    <!-- 同样的按钮工具栏 -->
    <v-card-actions>
      <v-btn color="orange" depressed :disabled="loadingIndicators['save'] === true || isReadonly"
             @click.native="onSave">
        {{ loadingIndicators['save'] ? '处理中...' : '保存' }}
      </v-btn>
      <v-btn color="secondary" depressed @click.native="goBack">返回</v-btn>
      <v-spacer/>
      <v-btn color="success" depressed :disabled="loadingIndicators['save'] === true || isReadonly"
             @click="validateForm">填写检查
      </v-btn>
    </v-card-actions>

    <x-msg
      v-model="showMsg"
      :message="message"
      :titleMessage="titleMessage"
      :onlyOk="true"
      v-on:ok="showMsg=false"
    />

    <x-submit
      v-model="submit"
      :dbid="submitDbid"
      :message="submitMsg"
      :data="submitData"
      :uri="submitUri"
      @ok="onAfterWfStep"
      @cancel="() => {loadingIndicators[submitDbid] = false}"
    />

    <wf-inst-hist
      v-model="wfHistDlg"
      :wf-inst="inst"
      @close="()=> wfHistDlg=false"
    />

  </v-container>


</template>
<script>

import mixin from '@/mixin'
import {mapGetters} from 'vuex'
import validators from '@/validators'

import dataPicker from '@/components/projLib/util/datePicker.vue';
import XUploader from '@/components/global/wf/Uploader'
import XMsg from '@/components/global/YesNoMsgBox'
import XSubmit from '@/components/global/wf/Submit'

import WfInstHist from "@/components/global/wf/WfInstHist.vue";

const baseURI = '/api/uflow/inst/';

export default {
  mixins: [validators, mixin.edit_page_fw(baseURI)],
  components: {dataPicker, XUploader, XMsg, XSubmit, WfInstHist},

  data() {
    return {
      // 是否处于编辑状态
      edit: false,

      // loading
      loadingIndicators: {"save": false},

      fileUri: '/api/projLib/2023/file',
      formValid: true,

      // 表单标签页
      tabs: null,

      // 流程实例
      inst: {},
      // 流程实例动作列表
      instActs: [],

      //
      showMsg: false,
      message: null,
      titleMessage: null,

      //保存数据时验证提示
      alert: false,

      submitUri: null,
      submit: false,
      submitDbid: null,
      submitData: {},
      submitMsg: null,

      // 部门列表
      deptItems: [],
      // 企业列表
      enterItems: [],

      // 州市列表

      cityItems: [
        '昆明市', '昭通市', '曲靖市', '玉溪市', '保山市', '楚雄州', '红河州', '文山州', '普洱市', '西双版纳州', '大理州', '德宏州', '丽江市', '怒江州', '迪庆州', '临沧市',
      ],
      typeItems:[
        "小巨人","专精特新","创新型"
      ],

      item: {
        "dbid": null
      },

      freshItem: {
        "dbid": null
      },

      showFormValidMsg: false,
      formValidErrors: [],

      wfHistDlg: false,
    }
  },

  created() {
    // 流程编号，如项目类、集群类
    this.fundId = this.$route.query.fundId;
  },

  watch: {},


  computed: {
    ...mapGetters(['funcIds']),
    isReadonly() {
      return window.viewDetail
      // return this.dbid && this.instActs.length === 0
    }
  },


  methods: {
    /**
     * 保存数据前对附件列表进行处理
     * 1.根据数组下标增加 group标记
     * 2.将文件的local标记值为null
     * 3.将所有文件放到一个列表 atts[]
     * 4.增加一个属性 attGroupNmu,记录最大的分组数
     */
    packAtt(data) {
      data.atts = []
      data.attGroupNmu = Array.isArray(data.attSeq) && data.attSeq.length > 0 ? data.attSeq.length - 1 : 0;
      for (let num = 0; num < data.attSeq.length; num++) {
        if (Array.isArray(data.attSeq[num])) {
          for (let i = 0; i < data.attSeq[num].length; i++) {
            data.attSeq[num][i].group = num;
            data.attSeq[num][i].local = false;
            data.atts.push(data.attSeq[num][i])
          }
        }
      }
      data.attSeq = []
    },

    /**
     * 读取数据后对附件列表进行处理
     * 1.将atts修改为attSeq【】
     * @param data
     */
    unpackAtt(data) {
      let atts = data.atts && Array.isArray(data.atts) ? data.atts : []
      let attGroupNmu = data.attGroupNmu | 0
      data.attSeq = []
      for (let i = 0; i < attGroupNmu + 1; i++) {
        data.attSeq[i] = atts.filter(v => v.group == i)
        if (Array.isArray(data.attSeq[i])) {
          for (let j = 0; j < data.attSeq[i].length; j++) {
            data.attSeq[i][j].local = false
          }
        } else {
          data.attSeq[i] = []
        }
      }
    },

    /**
     * 表单校验
     * @returns {boolean}
     */
    validateForm() {
      // 校验表单
      const errorInputs = this.$refs.formRef.inputs.filter(it => !it.validate(true))
      // 收集错误信息
      this.formValidErrors = errorInputs.map(it => {
        return {"fieldLabel": it.label || it.hint, "fieldErrors": it.errorBucket}
      })
      // 显示校验结果
      this.showFormValidMsg = true
      // 返回校验状态
      return this.formValidErrors.length === 0
    },

    goBack() {
      // let back_path = this.funcIds.includes('is_proj_manager') ? this.managePath : this.appPath;
      let back_path = "/smes/loan/2024V3/enterAdmin"
      this.$router.push({
        path: back_path + "?fundId=" + this.fundId
      });
    },

    /**
     * 保存数据后执行
     * @param rspData
     */
    afterSave(rspData) {
      if (rspData.dbid) {
        this.dbid = rspData.dbid
      }
      this.showMsg = true;
      this.titleMessage = "提示！";
      this.message = "数据保存成功！";

      // 更新流程实例
      this.inst = rspData
      // 更新流程实例的动作按钮
      this.instActs = rspData["acts"] || []

      // 禁用按钮
      this.loadingIndicators['save'] = false
    },


    /**
     * 读取数据后执行
     * @param rspData
     */
    afterGetData(rspData) {
      // 更新流程实例
      this.inst = rspData
      // 更新流程实例的动作按钮
      this.instActs = rspData["acts"] || []
      //附件处理
      // Object.assign(this.item, this.unpackAtt(rspData['formJson']))
      this.unpackAtt(this.item)
      // 根据 window.viewDetail判断当前是否为查看状态
      if (window.viewDetail && Array.isArray(this.instActs) && this.instActs.length > 0)
        this.instActs = Array(0)
    },

    /**
     * 保存数据前执行
     * @param data
     */
    beforeSendData(data) {
      // 将表单数据打包
      Object.assign(data, {"proj": {"name": data.enter ? data.enter.name : ''}})
      // 附件处理
      this.packAtt(data)
      // 禁用按钮
      this.loadingIndicators['save'] = true
    },

    /**
     * 推进流程实例
     * @param actDbid 流程状态转移边主键
     * @param actName 流程状态转移边名称
     */
    onWfStep(actDbid, actName) {
      if (!this.dbid) {
        this.showMsg = true;
        this.titleMessage = "提示！";
        this.message = "请保存数据后,再提交！";
      } else {
        // 表单校验不通过，不能提交
        if (!this.validateForm()) return;

        // 将表单数据打包
        const formJson = xutil.clone(this.item)
        // 处理附件
        this.packAtt(formJson)


        // 禁用按钮
        this.loadingIndicators[actDbid] = true

        this.submitMsg = actName
        this.submitUri = `${baseURI}step/${this.dbid}`
        this.submitDbid = actDbid
        this.submitData = formJson
        this.submit = true
      }
    },
    onAfterWfStep(rspData) {
      this.inst = rspData;
      this.instActs = rspData['acts'] || []

      // 禁用按钮
      this.loadingIndicators[this.submitDbid] = false
    }
  }
}
</script>
<style>
button.compact-btn {
  min-width: 3.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/smes/loan/v2024_3/enterEdit.vue